import React, { useContext, useState } from "react";
import AppContext from "../../store/app-context";
import {
  TextField,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Typography,
} from "@mui/material";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";

import styles from "./question.module.css";
import ButtonCircle from "../ButtonCircle/ButtonCircle";
import SnackBar from "../SnackBar/SnackBar";
import Recaptcha from "react-recaptcha";

const Question = ({ content }) => {
  const [rating, setRating] = useState([]);
  const [ratingValue, setRatingValue] = useState(0);
  const [choiceValue, setChoiceValue] = useState("");
  const [note, setNote] = useState("");
  const [dirty, setDirty] = useState("");
  const [serviceAdvisor, setServiceAdvisor] = useState("");
  const appCtx = useContext(AppContext);

  const ratingSales = [
    {
      id: 10,
      label: "Sangat puas, akan rekomendasi",
      value: 10,
    },
    {
      id: 9,
      label: "Puas, akan rekomendasi",
      value: 9,
    },
    {
      id: 8,
      label: "Puas, tidak akan rekomendasi",
      value: 8,
    },
    {
      id: 7,
      label: "Cukup puas, tidak akan rekomendasi",
      value: 7,
    },
    {
      id: 6,
      label: "Netral",
      value: 6,
    },
    {
      id: 5,
      label: "Kurang puas, tidak akan rekomendasi",
      value: 5,
    },
    {
      id: 4,
      label: "Tidak puas, tidak rekomendasi",
      value: 4,
    },
    {
      id: 3,
      label: "Tidak puas, tidak akan rekomendasi",
      value: 3,
    },
    {
      id: 2,
      label: "Sangat tidak puas, tidak rekomendasi",
      value: 2,
    },
    {
      id: 1,
      label: "Sangat tidak puas, tidak akan rekomendasi",
      value: 1,
    },
  ];

  const ratingService = [
    {
      id: 10,
      label: "Puas & Merekomendasikan",
      value: 10,
    },
    {
      id: 9,
      label: "Puas & Merekomendasikan",
      value: 9,
    },
    {
      id: 8,
      label: "Puas/Tidak Rekomendasi",
      value: 8,
    },
    {
      id: 7,
      label: "Puas/Tidak Rekomendasi",
      value: 7,
    },
  ];

  const handleServiceAdvisorChange = (e) => {
    setServiceAdvisor(e.target.value);
  };

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const handleInputChange = (e) => {
    setDirty(e.target.value);
  };

  const handleRating = (e) => {
    setRatingValue(e.target.value);
  };

  const handleChoice = (e) => {
    setChoiceValue(e.target.value);
  };

  const handleRatingMulti = (e, index) => {
    const updatedRating = [...rating];
    if (typeof updatedRating[index] === "undefined")
      updatedRating.push(e.target.value);
    else updatedRating[index] = e.target.value;

    setRating(updatedRating);
  };

  const handleNextBatch = () => {
    appCtx.handleBatchAnswer(rating);
    setRating([]);
  };

  const handleChoiceAnswer = () => {
    let choiceAnswer = choiceValue;
    if (dirty) choiceAnswer += `, ${dirty}`;
    appCtx.handleAnswer(choiceAnswer);
    setChoiceValue("");
  };

  const handleRateAndSubmit = () => {
    // appCtx.handleRating(ratingValue, false);
    appCtx.handleSubmit({ extra: "", newRating: ratingValue });
  };

  return (
    <>
      <ButtonCircle />
      <p className={styles.question}>
        {content.questions && content.questions[+appCtx.question].question}
      </p>
      {appCtx.hasError && <SnackBar type="error" message={appCtx.message} />}
      {content.questions &&
        content.questions[+appCtx.question].type === "boolean" && (
          <div className={styles.actions}>
            <button
              className={styles.button}
              onClick={() => appCtx.handleAnswer(1)}
            >
              Ya
            </button>
            <button
              className={styles.button}
              onClick={() => appCtx.handleAnswer(0)}
            >
              Tidak
            </button>
          </div>
        )}
      {content.questions &&
        content.questions[+appCtx.question].type === "input" && (
          <div className={[styles.actions, styles.text].join(" ")}>
            <TextField
              id="service_advisor"
              name="service_advisor"
              label="Nama Service Advisor"
              variant="standard"
              value={serviceAdvisor}
              onChange={handleServiceAdvisorChange}
              fullWidth
              sx={{ fontSize: 14 }}
              inputProps={{ maxLength: 20 }}
            />
            {serviceAdvisor && (
              <button
                className={[styles.button, styles.buttonSubmit].join(" ")}
                onClick={() => appCtx.handleAnswer(serviceAdvisor)}
              >
                Berikutnya
              </button>
            )}
          </div>
        )}
      {content.questions &&
        content.questions[+appCtx.question].type === "text" && (
          <div className={[styles.actions, styles.text].join(" ")}>
            <TextField
              id="kesan"
              name="kesan"
              label="kesan/saran"
              variant="standard"
              value={note}
              onChange={handleNoteChange}
              fullWidth
              sx={{ fontSize: 14 }}
            />
            <div style={{ marginTop: "20px" }}>
              <Recaptcha
                sitekey="6LdHIVsiAAAAAArfeMfuxq9g2Ta9e3YbeRQv-2lZ"
                render="explicit"
                verifyCallback={appCtx.handleVerifyCaptcha}
                onloadCallback={() => {}}
              />
            </div>
            {note && appCtx.isVerified && (
              <button
                className={[styles.button, styles.buttonSubmit].join(" ")}
                onClick={() => appCtx.handleSubmit({ extra: note })}
              >
                Kirim
              </button>
            )}
          </div>
        )}
      {content.questions &&
        content.questions[+appCtx.question].type === "multi" && (
          <>
            {content.questions[+appCtx.question].subquestion.map(
              (data, index) => (
                <div className={styles.subquestions} key={data.id}>
                  <div className={styles["subquestions-title"]}>
                    <DoneAllOutlinedIcon sx={{ fontSize: "12px" }} />{" "}
                    {data.category}
                  </div>
                  <div className={styles["subquestions-body"]}>
                    <div>{data["min-label"]}</div>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="rating-label"
                        name={`rating${data.id}`}
                        value={rating[index] || 0}
                        onChange={(e) => handleRatingMulti(e, index)}
                      >
                        {[...Array(data["max-value"])].map((x, i) => (
                          <FormControlLabel
                            key={i}
                            value={+i + 1}
                            control={
                              <Radio
                                size="small"
                                className={styles.radio}
                                sx={{
                                  padding: "1px",
                                  color: "#ed0000",
                                  "&.Mui-checked": {
                                    color: "#ed0000",
                                  },
                                }}
                              />
                            }
                            label={
                              <Typography className={styles["radio-label"]}>
                                {+i + 1}
                              </Typography>
                            }
                            labelPlacement="bottom"
                            sx={{ marginLeft: 0, marginRight: 0 }}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <div>{data["max-label"]}</div>
                  </div>
                </div>
              )
            )}
            {rating.length ===
              content.questions[+appCtx.question].subquestion.length && (
              <div className={styles.actions}>
                <button className={styles.button} onClick={handleNextBatch}>
                  Berikutnya
                </button>
              </div>
            )}
          </>
        )}
      {content.questions &&
        content.questions[+appCtx.question].type === "rating" && (
          <div className={[styles.actions, styles.rating].join(" ")}>
            <FormControl>
              <RadioGroup
                aria-labelledby="rating-label"
                name="rating"
                value={ratingValue}
                onChange={handleRating}
              >
                {appCtx.division.substring(0, 5) === "sales" &&
                  ratingSales.map((rating) => (
                    <FormControlLabel
                      key={rating.id}
                      value={rating.value}
                      control={<Radio size="small" />}
                      label={
                        <Typography className={styles["radio-label"]}>
                          {rating.value}. {rating.label}
                        </Typography>
                      }
                    />
                  ))}
                {appCtx.division === "service" &&
                  ratingService.map((rating) => (
                    <FormControlLabel
                      key={rating.id}
                      value={rating.value}
                      control={<Radio size="small" />}
                      label={
                        <Typography className={styles["radio-label"]}>
                          {rating.value}. {rating.label}
                        </Typography>
                      }
                    />
                  ))}
              </RadioGroup>
            </FormControl>
            {appCtx.division === "service" && (
              <div style={{ marginTop: "20px" }}>
                <Recaptcha
                  sitekey="6LdHIVsiAAAAAArfeMfuxq9g2Ta9e3YbeRQv-2lZ"
                  render="explicit"
                  verifyCallback={appCtx.handleVerifyCaptcha}
                  onloadCallback={() => {}}
                />
              </div>
            )}
            {ratingValue > 0 &&
              appCtx.division === "service" &&
              appCtx.isVerified && (
                <button
                  className={[styles.button, styles.buttonSubmit].join(" ")}
                  onClick={() => handleRateAndSubmit()}
                >
                  Kirim
                </button>
              )}
            {ratingValue > 0 && appCtx.division.substring(0, 5) === "sales" && (
              <button
                className={styles.button + " " + styles.buttonSubmit}
                onClick={() => appCtx.handleRating(ratingValue)}
              >
                Berikutnya
              </button>
            )}
          </div>
        )}
      {content.questions &&
        content.questions[+appCtx.question].type === "choice" && (
          <div className={[styles.actions, styles.rating].join(" ")}>
            <FormControl>
              <RadioGroup
                aria-labelledby="choice-label"
                name="choice"
                value={choiceValue}
                onChange={handleChoice}
              >
                {content.questions[+appCtx.question].options.map((data) => (
                  <div key={data.id}>
                    <FormControlLabel
                      value={data.value}
                      control={<Radio size="small" />}
                      label={
                        <Typography className={styles["radio-label"]}>
                          {data.value}
                        </Typography>
                      }
                    />
                    {data.input && (
                      <TextField
                        id={data.name}
                        name={data.name}
                        label={data.placeholder}
                        variant="standard"
                        value={dirty}
                        onChange={handleInputChange}
                        fullWidth
                        sx={{ fontSize: 14 }}
                        inputProps={{ maxLength: 100 }}
                        disabled={choiceValue !== "Kotor"}
                      />
                    )}
                  </div>
                ))}
              </RadioGroup>
            </FormControl>
            {choiceValue && (
              <button
                className={styles.button + " " + styles.buttonSubmit}
                onClick={handleChoiceAnswer}
              >
                Berikutnya
              </button>
            )}
          </div>
        )}
    </>
  );
};

export default Question;
